/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * @components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {FC} from 'react'
import {Redirect, Switch, Route} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {Logout, AuthPage, ByToken} from '../modules/auth'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {RootState} from '../../setup'
import {PATH_AUTH, ROOTS_AUTH, ROOTS_LOGOUT} from './paths'
import {ProductsProvider} from '../@contexts'

const Routes: FC = () => {

  const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)

  return (
    <Switch>
      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from={ROOTS_AUTH} to="/" />
      )}

      <Route path="/token" component={ByToken} />
      <Route path="/error" component={ErrorsPage} />
      <Route path={ROOTS_LOGOUT} component={Logout} />


      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to={PATH_AUTH.login} />
      ) : (
        <ProductsProvider>
          <MasterLayout>
            <PrivateRoutes />
          </MasterLayout>
        </ProductsProvider>
      )}
    </Switch>
  )
}

export {Routes}

